import { render, staticRenderFns } from "./ExhibitionMenus.vue?vue&type=template&id=bcef67f4&"
import script from "./ExhibitionMenus.vue?vue&type=script&lang=js&"
export * from "./ExhibitionMenus.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionMenus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports